import type { Opt } from '@jet/environment/types/optional';
import type { SetPersistenceItemAction } from './../../action-model/SetPersistenceItemAction';
import {
    type Persistence,
    PersistenceScope,
    type SerializableValue,
} from './Persistence';
import { type StorageKey, StorageKeys } from './StorageKeys';

export class Storage {
    constructor(persistence: Persistence) {
        this.persistence = persistence;
    }

    getItem(key: StorageKey): Opt<SerializableValue> {
        const scope = this.persistenceScopeForKey(key);
        return this.persistence.getValueForKey(key, scope);
    }

    setItemAction(
        key: StorageKey,
        item: SerializableValue,
        actionMetrics = { data: [], custom: {} },
    ): SetPersistenceItemAction {
        const scope = this.persistenceScopeForKey(key);
        return {
            $kind: 'setPersistenceItemAction',
            scope,
            item,
            actionMetrics,
            key,
        };
    }

    // MARK: Private

    private persistenceScopeForKey(key: StorageKey): PersistenceScope {
        return key in StorageKeys.User
            ? PersistenceScope.User
            : PersistenceScope.Device;
    }

    private readonly persistence: Persistence;
}

export default Storage;
